import { useState, useEffect } from 'react'

export const BREAKPOINTS = {
  mobile: 375,
  tablet: 768,
  laptop: 992,
  desktop: 1200,
  widescreen: 1400,
}

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(Boolean)

  useEffect(() => {
    function handleScreenResize() {
      setIsMobile(
        window.matchMedia(`(max-width: ${BREAKPOINTS.laptop - 1}px)`).matches
      )
    }

    window.addEventListener('resize', handleScreenResize)

    handleScreenResize()

    return () => window.removeEventListener('resize', handleScreenResize)
  }, [])

  return isMobile
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(Boolean)

  useEffect(() => {
    function handleScreenResize() {
      setIsTablet(
        window.matchMedia(`(max-width: ${BREAKPOINTS.tablet - 1}px)`).matches
      )
    }

    window.addEventListener('resize', handleScreenResize)

    handleScreenResize()

    return () => window.removeEventListener('resize', handleScreenResize)
  }, [])

  return isTablet
}
